<template>
  <div>
    <div v-if="note">
      <form v-on:submit.prevent="updateNoteVerbose(false)">
        <div class="mb-3" v-if="note && note.book">
          <div>
            <div class="form-group">
              <label class="for-reader">Doc Title:</label>
              <div v-if="note.book.type === 'simple'">
                <input
                  class="input-text-1 focus:shadow-outline focus:outline-0"
                  placeholder="Title"
                  type="text"
                  v-model="note.title"
                />
              </div>

              <div v-else-if="note.book.type === 'date'">
                <div>
                  <datepicker
                    :typeable="true"
                    class="datepicker-input-wrap"
                    format="MMM d, yyyy"
                    input-class="datepicker-input"
                    v-model="note.date"
                  />

                  <span>Title</span>
                  <input type="checkbox" v-model="showTitle" />
                </div>

                <input
                  class="input-text-1 focus:shadow-outline focus:outline-0"
                  placeholder="Title"
                  type="text"
                  v-if="showSepTitle"
                  v-model="note.title"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div>
            <div class="form-group" v-if="note">
              <label class="for-reader">Message Content:</label>
              <dreditor
                :update-note="updateNoteVerbose"
                :drid="`main-${note.id}`"
                v-if="
                  note.is_encrypted ||
                    (resourceAction === 'create' && note.book.encrypt)
                "
                v-model="note.encrypted"
              ></dreditor>

              <dreditor
                :update-note="updateNoteVerbose"
                :drid="`main-${note.id}`"
                v-else
                v-model="note.content"
              ></dreditor>
            </div>
          </div>
        </div>

        <div class="terms mb-2">
          <span :key="term.name" v-for="(term, idx) in note.terms">
            <span
              class="inline-block"
              v-on:click="deleteNoteTerm(term, note)"
            >
              <Zondicon class="w-3 cursor-pointer fill-current" icon="Close" />
            </span>
            {{ term.name }}<span v-if="idx !== note.terms.length - 1">, </span>
          </span>
        </div>

        <admin-note-terms-dropdown
          :note="note"
          class="mb-5 terms-search relative"
          v-if="note"
        ></admin-note-terms-dropdown>

        <move-dropdown :note="note" />


        <div>
          <button
            :class="{ 'bg-gray-600': hasChanged }"
            class="hover:bg-blue-700 button-1 mb-4"
          >
            Save Note
          </button>
          <div v-on:click="done">
            Done
          </div>
        </div>
      </form>

      <div>
        <div
          class="hover:bg-red-700 button-1 bg-red-600 mb-4 inline-block"
          v-if="note.new"
          v-on:click="deleteNote"
        >
          Cancel
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { API_URL } from "../../env.js";
import DREditor from "../DoxEditor.vue";
import AdminNoteTermsDropdown from "./AdminNoteTermsDropdown.vue";
import VisDropdown from "./VisDropdown.vue";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import MoveDropdown from "./MoveDropdown.vue";


export default {
  data() {
    return {
      autoSaveTimer: null,
      prevNoteContentLength: 0,
      resourceAction: "",
      showTitle: "",
      date: "2019-11-03 00:00:00"
    };
  },
  props: ["action", "noteId"],
  components: {
    // DatePicker,
    AdminNoteTermsDropdown,
    dreditor: DREditor,
    VisDropdown,
    Datepicker,
    MoveDropdown,
  },
  beforeDestroy: function() {
    clearInterval(this.autoSaveTimer);
    // If there's only one note, assume the user entered the single note page and only loaded one note and should get all the notes when going to the book
    if (this.$store.state.notes.notes.length === 1) {
      this.$store.dispatch("aSetNotes", { notes: [] });
    }
    // this.$refs.dreditor.clearContent();
  },

  methods: {
    done () {
      this.note.editing = false;
      this.$store.dispatch("aUpdateNotes", { notes: [this.note] });
    },
    deleteNoteTerm (term, note) {
      const termIndex = this.note.terms.findIndex(x => x.id === term.id);
      this.note.terms.splice(termIndex, 1);
      let termName = `[${term.name}]`;
      let termNameIndex = this.note.term_list.indexOf(termName);
      if (termNameIndex !== -1) {
        this.note.term_list = this.note.term_list.replace(termName, '');
      }
    },
    async updateNoteVerbose(saveAndClose = false) {
      if (saveAndClose) {
        this.note.editing = false;
      }
      this.$loading(true);
      await this.$store.dispatch("aUpdateNote", this.note);
      this.$store.dispatch("aSetHasChanged", false);
      this.$loading(false);
    },

    deleteNote() {
      this.$store.dispatch("aDeleteNote", this.note.id);
      if (this.$route.params.note) {
        this.$router.replace({ path: `/admin/notes?book=${this.note.book.id}` });
      }
    }
  },

  computed: {
    note() {
      const noteId = parseInt(this.noteId);
      const index = this.$store.state.notes.notes.findIndex(
        x => x.id === noteId
      );
      console.log("note index", index, this.$store.state.notes.notes, noteId);
      return this.$store.state.notes.notes[index];
    },
    oldNote() {
      return this.$store.state.notes.oldNote;
    },
    terms() {
      return this.$store.state.notes.terms;
    },
    showSepTitle() {
      let noteHasTitle =
        this.note && this.note.title !== "" && this.note.title !== null;
      return this.showTitle || noteHasTitle;
    },
    user() {
      return this.$store.state.notes.user;
    },
    hasChanged() {
      return this.$store.state.notes.has_changed;
    }
  },
  watch: {
    note: {
      handler: function(updatedNote, oldNote) {
        // Only start checking after everything has loaded at least once (checked by looking at the old note)
        if (oldNote !== undefined && oldNote !== null) {
          this.$store.dispatch("aSetHasChanged", true);
        }
      },
      deep: true
    }
  }
};
</script>
<style lang="scss">
.datepicker-input-wrap {
  background-color: #fff;
  border-width: 1px;
  border-color: #e2e8f0;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;

  display: block;
  width: 100%;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  line-height: 1.5;
}

.datepicker-input {
  padding-left: 1rem;
  padding-right: 1rem;
}
</style>
